import axios from 'axios';
import apiConfig from '../api.config';

export default function removeSliderImage({ hotelId, uid, url }) {
  const {
    host,
    URIs: { removeSliderImage },
  } = apiConfig;

  const uri = `${host}${removeSliderImage.replace(':hotelId', hotelId).replace(':uid', uid)}`;

  return axios
    .post(
      uri,
      { path: url },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    .then(res => {
      return res.data;
    });
}
